module.exports = __webpack_public_path__ + "img/visa.d0f34d60.svg";